@if (isEnabled && isLoggedIn()) {
  @if (!isOpen()) {
    <button
      class="wattson-fab"
      type="button"
      [class.wattson-fab--wrapped]="!showLabel()"
      (click)="open()"
      [attr.aria-label]="'WATTSON.OPEN_ARIA' | translate"
    >
      <span class="wattson-fab-inner">
        <mat-icon class="wattson-fab-spark">auto_awesome</mat-icon>
        <span class="wattson-fab-label">Wattson</span>
      </span>
    </button>
  }

  <div class="wattson-chat" [class.wattson-chat--open]="isOpen()">
    <div class="wattson-header">
      <pc-icon class="wattson-header-icon" name="batteryBolt" color="#fff"></pc-icon>
      <span class="wattson-title">{{ 'WATTSON.TITLE' | translate }}</span>
      <button
        mat-icon-button
        type="button"
        class="wattson-close-btn"
        (click)="close()"
        [attr.aria-label]="'WATTSON.CLOSE_ARIA' | translate"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="wattson-messages" #messageList>
      @for (message of aiStore.messages(); track $index) {
        <div
          class="message-tile"
          [class.message-tile--user]="message.role === 'user'"
          [class.message-tile--assistant]="message.role === 'assistant'"
        >
          @if (message.loading) {
            <span class="loading-dots"> <span></span><span></span><span></span> </span>
          } @else if (message.role === 'assistant') {
            <div class="message-tile__markdown" [innerHTML]="renderMarkdown(message.text)"></div>
          } @else {
            <span>{{ message.text }}</span>
          }
        </div>
      }
      @if (aiStore.messages().length === 0) {
        <p class="wattson-empty">{{ 'WATTSON.EMPTY_STATE' | translate }}</p>
      }
    </div>

    <div class="wattson-input-area">
      <input
        class="wattson-input"
        type="text"
        [(ngModel)]="inputText"
        (keydown)="onKeyDown($event)"
        [placeholder]="'WATTSON.INPUT_PLACEHOLDER' | translate"
        [disabled]="aiStore.isLoading()"
        [attr.aria-label]="'WATTSON.INPUT_ARIA' | translate"
      />
      <button
        mat-icon-button
        type="button"
        class="wattson-send-btn"
        (click)="sendMessage()"
        [disabled]="aiStore.isLoading() || !inputText.trim()"
        [attr.aria-label]="'WATTSON.SEND_ARIA' | translate"
      >
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
}
